import React, { Dispatch, PropsWithChildren, SetStateAction, createContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

interface FormatContext {
    
}

export const ContextGlobal = createContext<FormatContext>({} as FormatContext)

const GlobalProvider: React.FC<PropsWithChildren> = ({ children }) => {

    const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);
  

    return (
        <ContextGlobal.Provider value={{ }}>
            {children}
        </ContextGlobal.Provider>
    )
}

export default GlobalProvider
